export const ISSUES_WITHOUT_ACCOUNT_PAGE_FETCH_INITIAL_DATA = "ISSUES_WITHOUT_ACCOUNT_PAGE_FETCH_INITIAL_DATA";
export const ISSUES_WITHOUT_ACCOUNT_PAGE_FETCH_INITIAL_DATA_SUCCESS = "ISSUES_WITHOUT_ACCOUNT_PAGE_FETCH_INITIAL_DATA_SUCCESS";